import React from 'react';
import '../../styles/kyro-design.css';

const Terms: React.FC = () => {
  return (
    <div className="page">
      <div className="login-hero-min">
        <div className="hero-grid" />
        <div className="hero-glow" />
        <div className="hero-inner" style={{ textAlign: 'center', maxWidth: 'none' }}>
          <h1 style={{ fontSize: 'clamp(1.8rem, 3vw, 2.4rem)' }}>Terms & Conditions</h1>
          <p className="hero-sub" style={{ margin: '0.5rem 0 0', opacity: 0.7 }}>Last Updated: March 2, 2026</p>
        </div>
      </div>

      <div className="legal-content-min">
            <div>
              <h2>1. Acceptance of Terms</h2>
              <p>
                Welcome to Kyro Asset Management. By accessing or using our website, services, or any 
                information provided by us, you agree to be bound by these Terms and Conditions ("Terms"). 
                If you do not agree to these Terms, please do not use our website or services.
              </p>
              <p>
                These Terms constitute a legally binding agreement between you and Kyro Asset Management 
                ("we," "us," or "our"). We reserve the right to modify these Terms at any time, and your 
                continued use of our services constitutes acceptance of such modifications.
              </p>
            </div>

            <div>
              <h2>2. Definitions</h2>
              <div className="definition-list">
                <dl>
                  <dt>"Fund"</dt>
                  <dd>
                    Refers to Kyro India Opportunities Fund – I (scheme of Kyro Alternative Investment Trust – Category-II AIF),
                    a SEBI-registered Alternative Investment Fund (Category II) bearing SEBI Registration No. IN/AIF2/26-27/2191,
                    managed by Kyro Asset Management.
                  </dd>

                  <dt>"Investor"</dt>
                  <dd>
                    Any individual or entity who invests or intends to invest in the Fund, meeting 
                    the eligibility criteria prescribed by SEBI.
                  </dd>

                  <dt>"Services"</dt>
                  <dd>
                    Investment management services, advisory services, and related activities provided 
                    by Kyro Asset Management.
                  </dd>

                  <dt>"Website"</dt>
                  <dd>
                    The Kyro Asset Management website and all associated digital platforms.
                  </dd>
                </dl>
              </div>
            </div>

            <div>
              <h2>3. Eligibility and Investor Qualifications</h2>
              
              <h3>3.1 Investor Eligibility</h3>
              <p>Investment in the Fund is restricted to:</p>
              <ul>
                <li>High Net Worth Individuals (HNIs) as defined by SEBI</li>
                <li>Ultra High Net Worth Individuals (UHNIs)</li>
                <li>Family Offices</li>
                <li>Institutional Investors</li>
                <li>Corporate Treasuries</li>
                <li>Other entities meeting SEBI's eligibility criteria for AIF Category II</li>
              </ul>

              <h3>3.2 Minimum Investment</h3>
              <p>
                The minimum investment amount shall be as prescribed by SEBI regulations for Category II 
                AIFs (currently ₹1 crore or as amended from time to time).
              </p>

              <h3>3.3 KYC Requirements</h3>
              <p>
                All investors must complete KYC (Know Your Customer) procedures in accordance with PMLA 
                (Prevention of Money Laundering Act) and SEBI requirements before making any investment.
              </p>
            </div>

            <div>
              <h2>4. Investment Terms</h2>

              <h3>4.1 No Guarantee of Returns</h3>
              <p>
                Investments in the Fund are subject to market risks. Past performance is not indicative 
                of future results. We do not guarantee any specific returns or capital preservation.
              </p>

              <h3>4.2 Lock-in Period</h3>
              <p>
                Investments may be subject to a lock-in period as specified in the Fund's Private Placement 
                Memorandum (PPM). Early redemption may not be permitted or may be subject to penalties.
              </p>

              <h3>4.3 Fees and Charges</h3>
              <p>The Fund may charge the following fees:</p>
              <ul>
                <li>Management Fee: As specified in the PPM</li>
                <li>Performance Fee: Based on fund performance, as detailed in the PPM</li>
                <li>Administrative Expenses: As per actual costs incurred</li>
                <li>Other charges as disclosed in the offering documents</li>
              </ul>

              <h3>4.4 Subscription and Redemption</h3>
              <p>
                Subscription and redemption procedures, timelines, and conditions shall be as specified 
                in the Fund's PPM and subject to SEBI regulations.
              </p>
            </div>

            <div>
              <h2>5. Regulatory Compliance</h2>

              <h3>5.1 SEBI Registration</h3>
              <p>
                Kyro Asset Management acts as the Investment Manager to the SEBI-registered
                Alternative Investment Fund (Category II), bearing SEBI Registration No. IN/AIF2/26-27/2191.
              </p>

              <h3>5.2 Compliance with Laws</h3>
              <p>
                All activities shall be conducted in compliance with applicable laws including but not 
                limited to:
              </p>
              <ul>
                <li>SEBI (Alternative Investment Funds) Regulations, 2012</li>
                <li>Prevention of Money Laundering Act, 2002</li>
                <li>Income Tax Act, 1961</li>
                <li>Foreign Exchange Management Act, 1999</li>
                <li>Companies Act, 2013</li>
                <li>Other applicable securities and financial services regulations</li>
              </ul>
            </div>

            <div>
              <h2>6. Website Use and Restrictions</h2>

              <h3>6.1 Permitted Use</h3>
              <p>
                You may use our website for lawful purposes only, including viewing information about 
                our services, downloading publicly available documents, and submitting inquiries.
              </p>

              <h3>6.2 Prohibited Activities</h3>
              <p>You agree not to:</p>
              <ul>
                <li>Use the website for any unlawful purpose or in violation of these Terms</li>
                <li>Attempt to gain unauthorized access to our systems or networks</li>
                <li>Interfere with or disrupt the website's functionality</li>
                <li>Transmit viruses, malware, or harmful code</li>
                <li>Scrape, copy, or reproduce content without permission</li>
                <li>Impersonate any person or entity</li>
                <li>Engage in any activity that could harm our reputation or business</li>
              </ul>

              <h3>6.3 Account Security</h3>
              <p>
                If you create an account on our investor portal, you are responsible for maintaining 
                the confidentiality of your login credentials and for all activities under your account.
              </p>
            </div>

            <div>
              <h2>7. Intellectual Property</h2>

              <h3>7.1 Ownership</h3>
              <p>
                All content on this website, including text, graphics, logos, images, software, and 
                other materials, is the property of Kyro Asset Management or its licensors and is 
                protected by copyright, trademark, and other intellectual property laws.
              </p>

              <h3>7.2 Limited License</h3>
              <p>
                We grant you a limited, non-exclusive, non-transferable license to access and use the 
                website for personal, non-commercial purposes. This license does not permit you to:
              </p>
              <ul>
                <li>Modify, copy, or distribute website content</li>
                <li>Use content for commercial purposes</li>
                <li>Remove copyright or proprietary notices</li>
                <li>Transfer or sublicense your rights</li>
              </ul>

              <h3>7.3 Trademarks</h3>
              <p>
                "Kyro Asset Management," "Kyro Capital," and associated logos are trademarks of Kyro 
                Asset Management. Unauthorized use of these marks is prohibited.
              </p>
            </div>

            <div>
              <h2>8. Disclaimers and Limitations</h2>

              <h3>8.1 No Investment Advice</h3>
              <p>
                Information on this website is for general informational purposes only and does not 
                constitute investment advice, financial advice, or a recommendation to invest. You 
                should consult with qualified advisors before making any investment decisions.
              </p>

              <h3>8.2 Website Availability</h3>
              <p>
                We strive to maintain website availability but do not guarantee uninterrupted access. 
                The website may be unavailable due to maintenance, technical issues, or other reasons.
              </p>

              <h3>8.3 Third-Party Content</h3>
              <p>
                Our website may contain links to third-party websites or content. We are not responsible 
                for the accuracy, legality, or content of external sites.
              </p>

              <h3>8.4 Limitation of Liability</h3>
              <p>
                To the maximum extent permitted by law, Kyro Asset Management shall not be liable for 
                any indirect, incidental, special, consequential, or punitive damages arising from your 
                use of our website or services.
              </p>
            </div>

            <div>
              <h2>9. Indemnification</h2>
              <p>
                You agree to indemnify, defend, and hold harmless Kyro Asset Management, its affiliates, 
                officers, directors, employees, and agents from any claims, liabilities, damages, losses, 
                or expenses (including legal fees) arising from:
              </p>
              <ul>
                <li>Your violation of these Terms</li>
                <li>Your violation of any applicable laws or regulations</li>
                <li>Your violation of any third-party rights</li>
                <li>Your use or misuse of our website or services</li>
              </ul>
            </div>

            <div>
              <h2>10. Confidentiality</h2>
              <p>
                Any non-public information shared with you regarding the Fund, investment strategies, 
                or our business operations is confidential. You agree not to disclose such information 
                to third parties without our prior written consent.
              </p>
            </div>

            <div>
              <h2>11. Dispute Resolution</h2>

              <h3>11.1 Governing Law</h3>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of India, 
                without regard to conflict of law principles.
              </p>

              <h3>11.2 Arbitration</h3>
              <p>
                Any disputes arising from these Terms or your use of our services shall be resolved 
                through arbitration in accordance with the Arbitration and Conciliation Act, 1996. 
                The arbitration shall be conducted in [City], India, and the language shall be English.
              </p>

              <h3>11.3 Jurisdiction</h3>
              <p>
                Subject to the arbitration clause above, the courts of [City], India shall have 
                exclusive jurisdiction over any disputes.
              </p>
            </div>

            <div>
              <h2>12. Termination</h2>
              <p>
                We reserve the right to terminate or suspend your access to our website or services 
                at any time, without notice, for any reason, including violation of these Terms.
              </p>
              <p>
                Upon termination, your right to use the website shall immediately cease, but provisions 
                regarding intellectual property, disclaimers, indemnification, and dispute resolution 
                shall survive.
              </p>
            </div>

            <div>
              <h2>13. Miscellaneous</h2>

              <h3>13.1 Entire Agreement</h3>
              <p>
                These Terms, together with our Privacy Policy and any other agreements referenced herein, 
                constitute the entire agreement between you and Kyro Asset Management.
              </p>

              <h3>13.2 Severability</h3>
              <p>
                If any provision of these Terms is found to be invalid or unenforceable, the remaining 
                provisions shall continue in full force and effect.
              </p>

              <h3>13.3 Waiver</h3>
              <p>
                Our failure to enforce any right or provision of these Terms shall not constitute a 
                waiver of such right or provision.
              </p>

              <h3>13.4 Assignment</h3>
              <p>
                You may not assign or transfer these Terms without our prior written consent. We may 
                assign these Terms without restriction.
              </p>
            </div>

            <div>
              <h2>14. Contact Information</h2>
              <p>
                For questions about these Terms or our services, please contact us:
              </p>
              <div className="contact-box">
                <p><strong>Kyro Asset Management</strong></p>
                <p>Email: <a href="mailto:compliance@kyrocapital.in">compliance@kyrocapital.in</a></p>
                <p>Phone: +91 7777839078</p>
                <p>Address: [To be added]</p>
              </div>
            </div>

            <div className="important-notice" style={{ background: 'var(--blue-lt)', padding: '1rem', border: '1px solid rgba(68,114,196,0.2)', marginBottom: '1.5rem' }}>
              <h3>Important Notice</h3>
              <p>
                By using this website or our services, you acknowledge that you have read, understood, 
                and agree to be bound by these Terms and Conditions. If you do not agree, please 
                discontinue use immediately.
              </p>
              <p>
                These Terms are subject to change without prior notice. Please review them periodically 
                for updates.
              </p>
            </div>
      </div>
    </div>
  );
};

export default Terms;
